export const allianzBuergerNextContactValidation = (
  contact: ContactFull,
  lastCallContact: Nilable<ContactRefType>,
  _questionnaire: Nullable<CCTaskType>,
  _events: EventDetailWoContact[],
): [boolean, string] => {
  if (contact.id === lastCallContact?.id) {
    return [true, ""];
  }

  const allowedStates = [
    "Wiedervorlage",
    "Termin",
    "nicht interessiert",
    "nicht erreichbar",
    "ungültige Daten",
    "Dublette",
    "Klärungsbedarf",
  ];

  if (contact.status && allowedStates.includes(contact.status.name)) {
    return [true, ""];
  }

  const toolTipText =
    "Bitte rufen Sie diesen Kontakt erst an oder setzen Sie ihn auf eine der folgenden Statusmöglichkeiten: „Wiedervorlage“, „Termin“, „nicht interessiert“, „nicht erreichbar“, „Klärungsbedarf“";

  return [false, toolTipText];
};
